import { useState } from "react";
import { Building2, FileCheck2, KeyRound, Pause, Play } from "lucide-react";
import "./rental-animation.css";

export const RentalAnimation = () => {
  const [paused, setPaused] = useState(false);
  return <section className={`rental-animation ${paused ? "rental-animation--paused" : ""}`} aria-label="Animated rental property, lease and keys illustration" data-testid="rental-animation">
    <div className="rental-animation__sky" aria-hidden="true">
      <div className="rental-animation__building">
        <div className="rental-animation__roof"/>
        <div className="rental-animation__windows">{Array.from({ length: 12 }, (_, i) => <span className="rental-animation__window" style={{ "--delay": `${i * 0.35}s` }} key={i}/>)}</div>
        <div className="rental-animation__door"/>
      </div>
      <div className="rental-animation__plant"><span/><span/><span/></div>
      <div className="rental-animation__ground"/>
      <div className="rental-animation__document"><FileCheck2 size={34}/><span/><span/><span/></div>
      <div className="rental-animation__key"><KeyRound size={34}/></div>
    </div>
    <div className="rental-animation__steps" data-testid="rental-animation-steps">
      <span><Building2 size={17}/> Property</span><span><FileCheck2 size={17}/> Lease</span><span><KeyRound size={17}/> Keys</span>
    </div>
    <button type="button" className="rental-animation__pause" onClick={() => setPaused((value) => !value)} aria-label={paused ? "Play illustration" : "Pause illustration"} aria-pressed={paused} title={paused ? "Play illustration" : "Pause illustration"} data-testid="rental-animation-toggle">{paused ? <Play size={17}/> : <Pause size={17}/>}</button>
  </section>;
};